import { defineMessages } from 'react-intl';

export default defineMessages({
  goToHomePage: {
    id: 'view.appBar.ariaLabel.goToHomePage',
    defaultMessage: 'Go to home page',
  },
  openSearch: {
    id: 'view.appBar.openSearch',
    defaultMessage: 'Open search',
  },
  closeSearch: {
    id: 'view.appBar.closeSearch',
    defaultMessage: 'Close search',
  },
});
